import React from 'react'
import style from './BusinessSolution.module.css'
import { useTranslation } from 'react-i18next'
import Presentacion from './comps/Presentacion'
import MasProductos from './comps/MasProductos'
import Carrusel from '../../carrusel/Carrusel'
import Solicitar from './comps/Solicitar'
import PrimeraParte from './comps/PrimeraParte'
import SegundaParte from './comps/SegundaParte'

const BusinessSolution = () => {
  const [t] = useTranslation();
  return (
    <div className={style.container}>
      <Presentacion t={t} />
      <PrimeraParte t={t} />
      <SegundaParte t={t} />
      <Solicitar t={t} />
      <Carrusel t={t} />
      <MasProductos t={t} />
    </div>
  )
}

export default BusinessSolution